import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo.webp'
import _imports_1 from '@/assets/down-arrow.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Wiskers logo"
}, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "default"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "neglected" }, "|", -1)
const _hoisted_4 = { class: "language-select dropdown" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  "aria-hidden": "true"
}, null, -1)
const _hoisted_6 = { class: "menu" }

import { ref, watch, onMounted, nextTick } from "vue";

import NavAltButton from "./NavAltButton.vue";
import NavAltMenu from "./NavAltMenu.vue";
import { useRoute } from "vue-router";

import i18n from "@/i18n";
import { setI18nLanguage } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheHeader',
  setup(__props) {

let isNavAltOpen = ref(false);
let masterClose = ref(false);

function closeNavMenu() {
  masterClose.value = true;
  isNavAltOpen.value = false;
  nextTick(() => {
    masterClose.value = false;
  });
}

let smallerScreen = ref(false);

function onResize() {
  const vw = window.innerWidth || 0;

  if (vw < 900) {
    smallerScreen.value = true;
  } else {
    smallerScreen.value = false;
  }
}

const route = useRoute();
const isHomePage = ref(true);
const fadeTrigger = ref<boolean>(false);

let initialRouteChange = true;

if (route.name != "home") {
  isHomePage.value = false;
}

function headerOnRouteChange() {
  setTimeout(() => {
    if (route.name == "home") {
      isHomePage.value = true;
    } else {
      isHomePage.value = false;
    }
  }, 500);

  if (!initialRouteChange) {
    fadeTrigger.value = true;
    setTimeout(() => {
      fadeTrigger.value = false;
    }, 1000);
  }
}

async function navOnRouteChange() {
  masterClose.value = true;

  await nextTick();
  masterClose.value = false;
  isNavAltOpen.value = false;
}

watch(
  () => route.fullPath,
  () => {
    headerOnRouteChange();
    setTimeout(() => {
      navOnRouteChange();
    }, 500);
  }
);

let localeStr: string = i18n.global.locale;

function switchLocale(locale: string) {
  setI18nLanguage(i18n, locale);
  localeStr = i18n.global.locale;
}

onMounted(() => {
  window.addEventListener("resize", onResize);
  onResize();

  setTimeout(() => {
    headerOnRouteChange();
    initialRouteChange = false;
  }, 200);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    ref: "header",
    class: _normalizeClass(["coming-soon", { home: isHomePage.value, fade: fadeTrigger.value, alt: _unref(smallerScreen) }])
  }, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "header__logo"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    (!_unref(smallerScreen))
      ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_unref(localeStr)) + " ", 1),
              _hoisted_5
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (switchLocale('en'))),
                "aria-label": "Change locale to english"
              }, " EN "),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (switchLocale('pt'))),
                "aria-label": "Change locale to portuguse"
              }, " PT ")
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(NavAltButton, {
            onOpen: _cache[2] || (_cache[2] = ($event: any) => (_isRef(isNavAltOpen) //@ts-ignore
 ? isNavAltOpen.value = true : isNavAltOpen = true)),
            onClose: _cache[3] || (_cache[3] = ($event: any) => (_isRef(isNavAltOpen) //@ts-ignore
 ? isNavAltOpen.value = false : isNavAltOpen = false)),
            close: _unref(masterClose)
          }, null, 8, ["close"]),
          _createVNode(NavAltMenu, {
            onClose: closeNavMenu,
            class: _normalizeClass({ active: _unref(isNavAltOpen) })
          }, null, 8, ["class"])
        ], 64))
  ], 2))
}
}

})